<template>
  <div class="brand-logo-slider-area section-space--pt_90" :class="brandlogo">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="brand-logo-slider__container-area">
            <h3 class="section-title font-weight--light mb-15 wow move-up">
              In partnerships with:
            </h3>
            <div class="swiper-container brand-logo-slider__container">
              <div class="swiper-wrapper brand-logo-slider__wrapper">
                <swiper :options="swiperOption">
                  <div
                    class="swiper-slide agency-brand-logo brand-logo--slider"
                  >
                    <div class="brand-logo__image text-center">
                      <img
                        src="/l1.png"
                        class="img-fluid"
                        alt="brand logo"
                        style="height:90px;"
                      />
                    </div>
                  </div>
                  <div
                    class="swiper-slide agency-brand-logo brand-logo--slider"
                  >
                    <div class="brand-logo__image text-center">
                      <img
                        src="/l2.png"
                        class="img-fluid"
                        alt="brand logo"
                        style="height:90px;"
                      />
                    </div>
                  </div>
                  <div
                    class="swiper-slide agency-brand-logo brand-logo--slider"
                  >
                    <div class="brand-logo__image text-center">
                      <img
                        src="/l3.png"
                        class="img-fluid"
                        alt="brand logo"
                        style="height:90px;"
                      />
                    </div>
                  </div>
                  <div
                    class="swiper-slide agency-brand-logo brand-logo--slider"
                  >
                    <div class="brand-logo__image text-center">
                      <img
                        src="/l4.png"
                        class="img-fluid"
                        alt="brand logo"
                        style="height:90px;"
                      />
                    </div>
                  </div>
                  <div
                    class="swiper-slide agency-brand-logo brand-logo--slider"
                  >
                    <div class="brand-logo__image text-center">
                      <img
                        src="/l5.png"
                        class="img-fluid"
                        alt="brand logo"
                        style="height:90px;"
                      />
                    </div>
                  </div>
                  <div
                    class="swiper-slide agency-brand-logo brand-logo--slider"
                  >
                    <div class="brand-logo__image text-center">
                      <img
                        src="/l6.png"
                        class="img-fluid"
                        alt="brand logo"
                        style="height:90px;"
                      />
                    </div>
                  </div>
                  <!-- <div
                    class="swiper-slide agency-brand-logo brand-logo--slider"
                  >
                    <div class="brand-logo__image text-center">
                      <img
                        src="/l7.png"
                        class="img-fluid"
                        alt="brand logo"
                        style="height:90px;"
                      />
                    </div>
                  </div> -->
                  <div
                    class="swiper-slide agency-brand-logo brand-logo--slider"
                  >
                    <div class="brand-logo__image text-center">
                      <img
                        src="/l8.png"
                        class="img-fluid"
                        alt="brand logo"
                        style="height:90px;"
                      />
                    </div>
                  </div>
                  <!-- <div
                    class="swiper-slide agency-brand-logo brand-logo--slider"
                  >
                    <div class="brand-logo__image text-center">
                      <img
                        src="/l9.png"
                        class="img-fluid"
                        alt="brand logo"
                        style="height:90px;"
                      />
                    </div>
                  </div> -->
                </swiper>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BrandLogoCarouselTwo",
  props: ["brandlogo"],
  data() {
    return {
      swiperOption: {
        speed: 800,
        loop: true,
        autoplay: true,
        slidesPerView: 6,
        breakpoints: {
          991: {
            slidesPerView: 4,
          },
          767: {
            slidesPerView: 3,
          },
          575: {
            slidesPerView: 2,
          },
        },
      },
    };
  },
};
</script>
